export var jsonParseSandbox = function (stringJson, defaultJson) {
    if (defaultJson === void 0) { defaultJson = {}; }
    try {
        return JSON.parse(stringJson);
    }
    catch (error) {
        return defaultJson;
    }
};
